<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/KQ6kmH/tc-custom/9781426814471.jpg?1701061644473" alt="This image is the cover for the book Italian Boss's Mistress, Brides of L'Amour"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Italian Boss's Mistress, Brides of L'Amour
      </h1>
      <p class="bookDescription body article font2">
        <b>A career woman’s mistake at a party heats up her workplace in this classic contemporary romance by a <i>USA Today</i>–bestselling author.</b><br/><br/>A misunderstanding leads Pippa Stevenson into Andreo D’Alessio’s bed. He is a fabulous lover, but all the same, Pippa is overcome with shame because he’s her boss!<br/><br/>However, now Andreo has decided that he wants Pippa all to himself, in the boardroom and the bedroom. But business and pleasure are a tricky mix, and soon Andreo needs to find a way to persuade Pippa to accept his new proposition—to promote her from mistress to wife!<br/><br/><i>Originally published in 2004</i>.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lynne Graham
      </h2>
      
      <p class="authorDescription body article">Lynne Graham lives in Northern Ireland and has been a keen romance reader since her teens. Happily married, Lynne has five children. Her eldest is her only natural child. Her other children, who are every bit as dear to her heart, are adopted. The family has a variety of pets, and Lynne loves gardening, cooking, collecting allsorts and is crazy about every aspect of Christmas.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin Enterprises
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?38d0fea0